import ListLoadingElement from "@portal/components/atoms/listLoadingElement";

export const LoadingFunds = () => (
  <div>
    {new Array(18).fill(0).map((_, index) => (
      <div className="grid grid-cols-robot-funds md:grid-cols-robot-funds-md animate-pulse my-4" key={index}>
        <ListLoadingElement classNames="w-20" />
        <ListLoadingElement classNames="w-24" />
        <ListLoadingElement classNames="hidden justify-self-end md:flex w-16" />
        <ListLoadingElement classNames="hidden justify-self-end md:flex w-8" />
        <ListLoadingElement classNames="w-8 justify-self-end" />
        <ListLoadingElement classNames="w-8 justify-self-end" />
      </div>
    ))}
  </div>
);
